import React from 'react';
import { Grid, Button } from '@material-ui/core';
import styles from 'shared/styles';

export const testId = 'LoginButton';

export function SignInButtonImpl() {
  return (
    <Grid item xs={12}>
      <Button
        type="submit"
        style={styles.submitButton}
      >
        LOG IN
      </Button>
    </Grid>
  );
}

SignInButtonImpl.propTypes = {
};

export default (SignInButtonImpl);
